import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ConstElement from '../common/ConstElement';

export default class DetailMail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mail: {},
            first_last_name: '',
            email: '',
        }
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }
    
    /**
     * Init data
     */
    componentWillMount() {
        if (this.props.match.params.hasOwnProperty('id')) {
            //View detail mail
            const mailId = this.props.match.params.id;
            axios.get('/api/mails/' + mailId).then(response => {
                this.setData(response.data);
                axios.get('/api/mails/' + this.state.mail.destination + '/' + this.state.mail.destination_id).then(response => {
                    this.setState({
                        first_last_name: response.data.first_last_name,
                        email: response.data.email,
                    })
                });
            }).catch(() => {
                this.props.history.push('/_404');
            })
            
        }
    }
    
    /**
     * Set data of mail
     * data: Object Mail
     */
    setData(data) {
        this.setState({
            mail: data
        })
    }
    
    /**
     * Get data of mail
     */
    getData() {
        return this.state.mail;
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/mails">メール配信一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">メール配信詳細</li>
                            </ol>
                        </nav>
                    </div>
		</div>
		<main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                            <div className="card mb-3">
                                <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">メール配信詳細</h4></div>
                                    <div className="card-body">
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">宛先</label>
                                            <div className="col-sm-8">
                                               <ConstElement element ="mails.destination" value={this.state.mail.destination ? this.state.mail.destination : ''} className="form-control" disabled="1" />
                                            </div>
                                        </div>
                                        { this.state.mail.destination == 6 ?
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">依頼者ID</label>
                                            <div className="col-sm-8">
                                                <input type="text" value={this.state.mail.destination_id ? this.state.mail.destination_id : ''} name='destination_id' readOnly className="form-control" />
                                            </div>
                                        </div>
                                        : '' }
                                        { this.state.mail.destination == 6 ?
                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label text-right"></label>
                                                <div className="col-sm-8">
                                                    <label className="col-value text-left"><span className="badge bg-pink text-white">依頼者</span> {this.state.first_last_name ? this.state.first_last_name : ''} { this.state.email ? " ("+this.state.email+")" : ''}</label>
                                                </div>
                                            </div>
                                        : '' }
                                        { this.state.mail.destination == 7 ?
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">ワーカーID</label>
                                            <div className="col-sm-8">
                                                <input type="text" value={this.state.mail.destination_id ? this.state.mail.destination_id : ''} name='destination_id' readOnly className="form-control" />
                                            </div>
                                        </div>
                                        : '' }
                                        { this.state.mail.destination == 7 ?
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right"></label>
                                            <div className="col-sm-8">
                                                <label className="col-value text-left"><span className="badge bg-purple text-white">ワーカー</span> {this.state.first_last_name ? this.state.first_last_name : ''} { this.state.email ? " ("+this.state.email+")" : ''}</label>
                                            </div>
                                        </div>
                                        : '' }
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">配信</label>
                                            <div className="col-sm-8">
                                                <ConstElement element ="mails.type" value={this.state.mail.type ? this.state.mail.type : ''} disabled="1" />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">タイトル</label>
                                            <div className="col-sm-8">
                                                <input type="text" name='title' readOnly value={this.state.mail.title ? this.state.mail.title : ''} className="form-control" />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">内容</label>
                                            <div className="col-sm-8">
                                                <textarea name='content' readOnly value={this.state.mail.content ? this.state.mail.content : ''} className="form-control" rows="8"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                <div className="card-footer text-center">
                                    <a onClick={this.handleRedirect} href="/mails" className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">戻る</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}
